<template>
  <div
    :class="[
      Classes.TILE_GUIDE_STATS,
      'tw-text-xs tw-flex tw-items-center mod-button-transition tw-justify-between tw-w-full',
    ]"
  >
    <tooltip-hover :text="readingStats.label">
      <item-card-footer-stat
        :label="readingStats.label"
        :icon="readingStats.icon"
        :text="`${readingStats.value} ${t('minutes_read').toLowerCase()}`"
      />
    </tooltip-hover>
    <div class="tw-flex tw-justify-end">
      <tooltip-hover :text="viewStats.label" class="tw-mr-4">
        <item-card-footer-stat
          :label="viewStats.label"
          :icon="viewStats.icon"
          :text="viewStats.value"
        />
      </tooltip-hover>
      <tooltip-hover :text="commentStats.label" class="tw-mr-4 tw-capitalize">
        <item-card-footer-stat
          :label="commentStats.label"
          :icon="commentStats.icon"
          :text="commentStats.value"
        />
      </tooltip-hover>
    </div>
  </div>
</template>

<script>
import ItemCardFooterStat from '@components/List/ItemCardFooterStat.vue'
import { numberFormatter, getReadingTime } from '@helpers/utils.js'
import TooltipHover from '@components/Message/TooltipHover.vue'
import Classes from '@shared/js/config/css.js'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
export default {
  components: {
    ItemCardFooterStat,
    TooltipHover,
  },
  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
    dateLive: {
      type: Number,
      default: 0,
    },
    dateUpdated: {
      type: Number,
      default: 0,
    },
    browseId: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const readingTime = computed(() => {
      if (props.description) {
        const { minutes } = getReadingTime(props.description)
        return Math.ceil(Math.max(minutes, 1))
      }

      return 1
    })

    const viewStats = computed(() => ({
      label: t('views'),
      value: numberFormatter(props.stats?.visits_total || 0),
      icon: 'eye',
    }))

    const readingStats = computed(() => ({
      label: t('reading_time'),
      value: readingTime.value,
      icon: 'book-open',
    }))

    const commentStats = computed(() => ({
      label: t('comment', 2),
      value: numberFormatter(props.state?.comments_total || 0),
      icon: 'comment',
    }))

    return {
      numberFormatter,
      readingStats,
      commentStats,
      viewStats,
      Classes,
      t,
    }
  },
}
</script>
